export default __webpack_public_path__ + "static/media/calendar.2afc8e12.svg";